import Footer from "../../../navigation/footerContainer";
import AdminPropertiesContainer from "./managePropertiesContainer";


export default function ManagePropertiesPage() {
    return (
        <>
            <AdminPropertiesContainer />
            <Footer />
        
        </>
    )

}